
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import DateField from './DateField';
import QuantityField from './QuantityField';
import { HarvestFormValues } from './schema';

interface ProgressSectionProps {
  form: UseFormReturn<HarvestFormValues>;
}

const ProgressSection: React.FC<ProgressSectionProps> = ({ form }) => {
  const status = form.watch('status');
  
  if (status !== 'in_progress' && status !== 'completed') {
    return null;
  }
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <DateField 
        form={form} 
        name="actual_date" 
        label="Actual Date" 
      />
      <QuantityField 
        form={form} 
        name="actual_quantity" 
        label="Actual Quantity (kg)" 
      />
    </div>
  );
};

export default ProgressSection;
